import React, { useState, useEffect } from "react";

import Header from "../OrderManagement/Header";
import Input from "../../ui/Input";
import Select from "../../ui/Select";
import DateField from "../../ui/DateField";
import Time from "../../ui/Time";

import { headers, attachmentHeaders } from "../../utils/utils";

import {
  Box,
  Grid,
  Switch,
  Button,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";

import {
  Inbox as InboxIcon,
  Info as InfoIcon,
  Code as CodeIcon,
  Label as LabelIcon,
  Category as CategoryIcon,
  CurrencyExchange as PriceChangeIcon,
  Receipt as ReceiptIcon,
  TextFields as TextFieldsIcon,
  Inventory as InventoryIcon,
  PhotoCamera as PhotoCameraIcon,
  Save as SaveIcon,
  AddCircle as AddCircleIcon,
  RemoveCircle as RemoveCircleIcon,
} from "@mui/icons-material";


const Form = () => {
  const [messageType, setMessageType] = useState("success");
  const [message, setMessage] = useState("");
  const [messageOpen, setMessageOpen] = useState(false);

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "#E9E9EA",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const [image, setImage] = useState(null);

  const [formData, setFormData] = useState({
    id: '',
    name: '',
    description: '',
    code: '',
    hsnCode: '',
    categoryId: '',
    salePrice: '',
    purchasePrice: '',
    onlineOrder: false,
    stockTracking: false, // For Stock Tracking switch
    stockAlert: false, // For Stock Alert switch
    batchTracking: false, // For Batch Tracked switch
    minStock: '', // Min stock input field
    reorder: '', // Reorder input field
    customFields: {},
    unitOfMeasurement: [
      {
        name: "",
        value: 0,
        displayOrder: 1,
      },
    ],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "uom") {
      // Update the main UOM in the unitOfMeasurement array
      setFormData((prevData) => ({
        ...prevData,
        unitOfMeasurement: [
          {
            ...prevData.unitOfMeasurement[0],
            name: value, // Map the main UOM value to name
            value: 0, // Example value (can be dynamic)
            displayOrder: 1,
          },
          // Map additionalFields to unitOfMeasurement
          ...additionalFields.map((field, index) => ({
            name: field.uom, // Map uom to name
            value: parseFloat(field.value) || 0, // Convert value to a number
            displayOrder: index + 2, // Set displayOrder dynamically
          })),
        ],
      }));
    } else {
      // Handle other fields
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const imageSave = async (data) => {
    const formData1 = new FormData();

    Array.from(data).forEach((file) => formData1.append("files", file));

    const response = await fetch(
      process.env.REACT_APP_ITEM,
      "/item/imageSave",
      {
        method: "POST",
        headers: attachmentHeaders(),
        body: formData1,
      },
    );

    if (response.ok) {
      const result = await response.json();
      console.log("Item saved successfully:", result);
    } else {
      const errorText = await response.text();
      console.error("Error saving item:", errorText);
    }
  };

  const itemSave = async () => {
    console.log("Save button clicked", formData);
    if (formData.name) {
      // Ensure customFields is an object, not an array
      const updatedCustomFields1 = Object.fromEntries(
        Object.entries(formData.customFields).map(([key, value]) => [key, value])
      );
  
      const updatedFormData = {
        ...formData,
        customFields: updatedCustomFields1, // Correctly formatted object
      };
  
      console.log("updatedFormData", updatedFormData); 
  
      const response = await fetch(process.env.REACT_APP_ITEM + "/item/save", {
        method: "POST",
        body: JSON.stringify(updatedFormData),
        headers: headers(),
      });
  
      if (response.ok) {
        const result = await response.json();
        console.log("Item saved successfully:", result);
  
        if (result.id) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            id: result.id,
          }));
          setIsVisible(true);
          setIsVisible(true);
          setMessage("Item saved successfully");
          setMessageOpen(true);
          setMessageType("success");
        }
      } else if (response.status === 409) {
        const error = await response.json();
        console.error("Conflict error:", error.message || "A conflict occurred.");
        setMessage(error.message || "Item already exists with the same details.");
        setMessageOpen(true);
        setMessageType("error");
      } else {
        console.error(
          `Failed to save item: ${response.status} ${response.statusText}`,
        );
      }
    }
  };
  

  const handleSwitchChange = (event) => {
    const { name, checked } = event.target; // Extract name and checked status
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Update the state for the toggled switch
    }));
  };

  const handleAllUomChange = (event) => {
    console.log("ERROR", event);
    console.log("ERROR", event.target.value);
    // setUomList((prevFormData) => ({
    //   ...prevFormData,
    //   event.target.value,
    // }));
  };

  const [isVisible, setIsVisible] = useState(false);
  const [customField, setCustomField] = useState([]);
  const [uomList, setUomList] = useState([]);

  useEffect(() => {
    const initializedCustomFields = customField.map((field) => ({
      label: field.label, // Use 'label' instead of 'name'
      value: "", // Default empty value
    }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      customFields: initializedCustomFields,
    }));
  }, [customField]); // Run this whenever `customField` changes
  // Function to fetch custom fields from API
  const fetchCustomFields = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_SYS_CONFIG_MGMT +
          "/systemConfig/getDynamicFields?screenName=Item Screen",
        {
          method: "GET",
          headers: headers(),
        },
      );
      if (!response.ok) {
        throw new Error("Failed to fetch custom fields");
      }
      const data = await response.json(); // Assuming the API returns JSON data
      setCustomField(data); // Update the state with API response
      console.log("res", data);
    } catch (error) {
      console.error("Error fetching custom fields:", error);
    }
  };

  const handleCustomFieldChange = (key, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      customFields: {
        ...prevFormData.customFields, // Keep existing fields
        [key]: value, // Update the specific field using its key
      },
    }));
  };
  



  // const customField = [{ label: "Demo Amount", icon: "Price", type: "amount" }, { label: "Field 2", icon: "Price", type: "amount" }]

  const [images, setImages] = useState([]); // Array to hold multiple images
  const [imagesData, setImagesData] = useState([]);

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to an array

    // Create previews for the frontend
    const newPreviews = files.map((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImages((prevImages) => [...prevImages, reader.result]);
      };
      reader.readAsDataURL(file); // Generate Base64 preview
      return reader.result;
    });

    // Update files state and call imageSave
    setImagesData((prevImages) => {
      const updatedFiles = [...prevImages, ...files];
      imageSave(updatedFiles); // Call imageSave with the updated files
      return updatedFiles;
    });
  };

  const handleDeleteImage = (index) => {
    // Update images and imagesData state
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImagesData((prevImagesData) => {
      const updatedImagesData = prevImagesData.filter((_, i) => i !== index);

      // Call imageSave with the updated data
      imageSave(updatedImagesData);

      return updatedImagesData; // Ensure state is updated correctly
    });
  };

  const [uom, setUom] = useState("");
  const [additionalFields, setAdditionalFields] = useState([]);

  const handleUomChange = (event) => {
    setUom(event.target.value);
  };

  const handleAddField = () => {
    setAdditionalFields([...additionalFields, { uom: "", value: "" }]);
  };

  const handleRemoveField = (index) => {
    const updatedFields = additionalFields.filter((_, i) => i !== index);

    setAdditionalFields(updatedFields);

    // Update formData to reflect changes in unitOfMeasurement
    setFormData((prevData) => ({
      ...prevData,
      unitOfMeasurement: [
        prevData.unitOfMeasurement[0], // Include the main UOM
        ...updatedFields.map((field, i) => ({
          name: field.uom, // Map uom to name
          value: parseFloat(field.value) || 0,
          displayOrder: i + 2,
        })),
      ],
    }));
  };

  const handleFieldChange = (index, field, value) => {
    const updatedFields = [...additionalFields];
    updatedFields[index][field] = value;
    setAdditionalFields(updatedFields);

    // Update formData to reflect changes in unitOfMeasurement
    setFormData((prevData) => ({
      ...prevData,
      unitOfMeasurement: [
        prevData.unitOfMeasurement[0], // Include the main UOM
        ...updatedFields.map((field, i) => ({
          name: field.uom, // Map uom to name
          value: parseFloat(field.value) || 0,
          displayOrder: i + 2,
        })),
      ],
    }));
  };

  return (
    <>
      <Header />

      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: 100,
          borderRadius: 2,
          background: "white",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          padding="16px"
        >
          <Typography
            variant="h6"
            style={{ display: "flex", alignItems: "center" }}
          >
            <InboxIcon style={{ marginRight: "8px" }} />
            Create Item
          </Typography>
          <Button
            variant="contained"
            color="primary"
            startIcon={<InboxIcon />}
            component={RouterLink} // React Router Link
            to="/item" // New Item path
          >
            Item List
          </Button>
        </Box>
        <hr className="hr" />
        <Typography
          variant="h6"
          className="vyg-subtitle-b"
          sx={{
            fontWeight: "bold",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            color: "#333",
            mb: 2,
          }}
        >
          Item Basic Information
        </Typography>

        <Grid container spacing={5} className="form-l1">
          <Input
            label="Name *"
            name="name"
            icon={InfoIcon}
            grid="3"
            placeHolder="e.g., Item 1"
            onBlur={handleInputChange}
          />

          <Input
            label="Description"
            name="description"
            fullWidth
            icon={LabelIcon}
            grid="3"
            placeHolder="e.g., Sample Description"
            onBlur={handleInputChange}
          />

          <Input
            label="Code"
            name="code"
            icon={CodeIcon}
            grid="3"
            placeHolder="e.g., 123456"
            onBlur={handleInputChange}
          />

          <Input
            label="HSN Code"
            name="hsnCode"
            icon={LabelIcon}
            grid="3"
            placeHolder="e.g., 987654"
            onBlur={handleInputChange}
          />

          <Select label="Category" name="categoryId" groupName="ItemCategory" icon={CategoryIcon} grid="3" placeHolder="e.g., Electrical" onChange={handleInputChange} />


          <Grid item xs={1}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <InventoryIcon style={{ fontSize: "1.7em" }} />
              <span className="form-l1" style={{ fontSize: "16px" }}>
                Stock Track
              </span>
            </div>

            <br />
            <IOSSwitch
              name="stockTracking"
              checked={formData.stockTracking}
              onChange={handleSwitchChange}
              inputProps={{ "aria-label": "Stock Tracking" }}
            />
          </Grid>

          {formData.stockTracking ? (
            <>
              <Grid item xs={1}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <InventoryIcon style={{ fontSize: "1.7em" }} />
                  <span className="form-l1" style={{ fontSize: "16px" }}>
                    Batch Track
                  </span>
                </div>
                <br />
                <IOSSwitch
                  name="batchTracking"
                  checked={formData.batchTracking}
                  onChange={handleSwitchChange}
                  inputProps={{ "aria-label": "Batch Tracked" }}
                />
              </Grid>

              <Grid item xs={1}>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <InventoryIcon style={{ fontSize: "1.7em" }} />
                  <span className="form-l1" style={{ fontSize: "16px" }}>
                    {" "}
                    Stock Alert
                  </span>
                </div>
                <br />

                <IOSSwitch
                  name="stockAlert"
                  checked={formData.stockAlert}
                  onChange={handleSwitchChange}
                  inputProps={{ "aria-label": "Stock Alert" }}
                />
              </Grid>

              {formData.stockTracking && formData.stockAlert && (
                <Grid item xs={3}>
                  <Grid container spacing={1}>
                    <Input
                      label="Min Stock"
                      name="minStock"
                      icon={InfoIcon}
                      grid="6"
                      placeHolder="Enter Min Stock"
                      value={formData.minStock}
                      onChange={handleInputChange}
                    />

                    <Input
                      label="Reorder Level Stock"
                      name="reorder"
                      icon={InfoIcon}
                      grid="6"
                      placeHolder="Enter Reorder Level"
                      value={formData.reorder}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          ) : (
            <Grid item xs={2}></Grid>
          )}
          <Input
            label="Sale Price"
            name="salePrice"
            icon={PriceChangeIcon}
            grid="3"
            placeHolder="e.g., 500"
            onBlur={handleInputChange}
          />

          <Input
            label="Purchase Price"
            name="purchasePrice"
            icon={ReceiptIcon}
            grid="3"
            placeHolder="e.g., 300"
            onBlur={handleInputChange}
          />

          <Grid item xs={3}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <InventoryIcon style={{ fontSize: "1.7em" }} />
              <span className="form-l1" style={{ fontSize: "16px" }}>
                Online
              </span>
            </div>

            <br />
            <IOSSwitch
              name="onlineOrder"
              checked={formData.onlineOrder}
              onChange={handleSwitchChange}
              inputProps={{ "aria-label": "Stock Tracking" }}
            />
          </Grid>

          {customField.map((field) => {
  const InputComponent =
    field.inputType === 'text' ? Input :
    field.inputType === 'date' ? Date :
    field.inputType === 'time' ? Time :
    field.inputType === 'select' ? Select : Input;

  return (
    <InputComponent
      key={field.label} // Use field label as key
      label={field.label}
      icon={TextFieldsIcon}
      grid="3"
      value={formData.customFields[field.label] || ''} // Access value using field.label
      onChange={(e) => handleCustomFieldChange(field.label, e.target.value)}
      placeHolder={field.placeholder}
    />
  );
})}  

        </Grid>

        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
            color: "#333",
            mb: 2,
          }}
        >
          Unit Of Measurements
        </Typography>

        <br />
        <Grid container spacing={5}>
          <Grid item xs={3}>
            <Select
              label="Uom"
              name="uom"
              groupName="ItemUom"
              icon={CategoryIcon}
              grid="12"
              placeHolder="e.g., kg"
              onChange={(e) => {
                handleInputChange(e);
                handleAllUomChange(e);
              }}
            />
            <br />
            {additionalFields.length === 0 && (
              <Button
                variant="contained"
                color="default"
                onClick={handleAddField}
                startIcon={<AddCircleIcon />}
              >
                Additional UOM
              </Button>
            )}

            {additionalFields.map((field, index) => (
              <Grid
                container
                spacing={2}
                key={index}
                alignItems="center"
                mt={2}
              >
                <Grid item xs={4}>
                  <Select
                    label="SubUom"
                    name="subUom"
                    groupName="ItemUom"
                    icon={CategoryIcon}
                    grid="12"
                    placeHolder="e.g., no"
                    onChange={handleFieldChange}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Input
                    label="Value"
                    name="code"
                    icon={CodeIcon}
                    grid="12"
                    placeHolder="e.g., 123456"
                    onBlur={handleInputChange}
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    color="primary"
                    onClick={handleAddField}
                    title="Add More"
                  >
                    <AddCircleIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    color="error"
                    onClick={() => handleRemoveField(index)}
                    title="Remove"
                  >
                    <RemoveCircleIcon />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Dynamically Added Fields */}

        <br />
        <br />

        {customField.map((field, index) => {
          const InputComponent =
            field.inputType === "text"
              ? Input
              : field.inputType === "date"
                ? DateField
                : field.inputType === "time"
                  ? Time
                  : field.inputType === "select"
                    ? Select
                    : Input;

          return (
            <Grid ontainer spacing={5} className="form-l1" key={index}>
              <InputComponent
                label={field.label}
                icon={TextFieldsIcon}
                grid="3"
                value={formData.customFields[index]?.value || ""}
                onChange={(e) => handleCustomFieldChange(index, e.target.value)}
                placeHolder={field.placeholder}
              />
            </Grid>
          );
        })}

        <hr className="hr" />

        <Button
          variant="contained"
          color="success"
          startIcon={<SaveIcon />}
          onClick={itemSave}
        >
          Save & Continue
        </Button>

        <br />
        <br />
        <br />
        <br />
        {isVisible && (
          <Grid item xs={12}>
            <Paper
              elevation={1}
              sx={{
                padding: 3,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Upload Your Images
              </Typography>

              {images.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {images.map((image, index) => (
                    <div
                      key={index}
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: 150,
                        height: 150,
                      }}
                    >
                      <img
                        src={image}
                        alt={`Preview ${index}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "8px",
                        }}
                      />
                      <IconButton
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          backgroundColor: "rgba(255,255,255,0.8)",
                        }}
                        size="small"
                        onClick={() => handleDeleteImage(index)}
                      >
                        ✖
                      </IconButton>
                    </div>
                  ))}
                </div>
              ) : (
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  No images selected.
                </Typography>
              )}

              <input
                accept="image/*"
                id="upload-images"
                type="file"
                hidden
                multiple // Allow multiple file uploads
                onChange={handleImageChange}
              />

              <label htmlFor="upload-images">
                <IconButton component="span">
                  <PhotoCameraIcon />
                </IconButton>
              </label>

              <Button
                variant="contained"
                color="primary"
                component="span"
                onClick={() => document.getElementById("upload-images").click()}
                sx={{ marginTop: 2 }}
              >
                Choose Images
              </Button>
            </Paper>
          </Grid>
        )}
      </Box>
    </>
  );
};
export default Form;
